export default "__VITE_ASSET__Ch3eUvOP__"